import { CLOUDINARY_PREFIX, MOCK_UP_LAYERS } from '../constants';

const {
    IMAGE_LAYER,
    VARIATION_LAYER,
    GRADIENT_LAYER
} = MOCK_UP_LAYERS;

const IPHONES_BEAUTY_LEFT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463825/IPHONES_BEAUTY_LEFT.png`;
const IPHONES_GRAPHICS_INSTAGRAM = `${CLOUDINARY_PREFIX}1bf9caef1f955bd2b7bd7e555e3661bd-1576154985979/Graphics_Instagram.png`;
const IPHONES_BEAUTY_RIGHT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463836/IPHONES_BEAUTY_RIGHT.png`;
const IPHONES_AO_LEFT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463821/IPHONES_AO%20LEFT.png`;
const IPHONES_AO_RIGHT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463830/IPHONE_AO_RIGHT.png`;
const IPHONES_GRAPHICS_FACEBOOK = `${CLOUDINARY_PREFIX}1bf9caef1f955bd2b7bd7e555e3661bd-1576154985962/Graphics_Facebook.png`;
const IPHONES_SHADOW_LEFT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463826/IPHONE_SHADOW_LEFT.png`;
const IPHONES_SHADOW_RIGHT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463841/IPHONE_SHADOW_RIGHT.png`;
const IPHONES_REFLECT_LEFT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463829/IPHONE_REFLECT_LEFT.png`;
const IPHONES_REFLECT_RIGHT = `${CLOUDINARY_PREFIX}76c03672be9d4f0017047f759e80518d-1576155463834/IPHONE_REFLECT_RIGHT.png`;

const WIDE_SCALE = 0.149;
const SQUARE_SCALE = 0.269;
const SQUARE_CROP_STYLE = {
    transformOrigin: 'center',
    transform: 'translate(0, 39%) scale(1.8)'
};

export const wideMockUp = {
    layers: [{
        type: GRADIENT_LAYER,
        opacity: 0.54,
        background: 'transparent'
    }, {
        type: IMAGE_LAYER,
        src: IPHONES_BEAUTY_LEFT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.18,
        mixBlendMode: 'multiply',
        src: IPHONES_BEAUTY_LEFT
    }, {
        type: IMAGE_LAYER,
        mixBlendMode: 'multiply',
        src: IPHONES_GRAPHICS_INSTAGRAM
    }, {
        type: VARIATION_LAYER,
        transform: `translate(-57.9%, -55%) rotate(-13.2deg) scale(${WIDE_SCALE})`
    }, {
        type: IMAGE_LAYER,
        src: IPHONES_BEAUTY_RIGHT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.18,
        mixBlendMode: 'multiply',
        src: IPHONES_BEAUTY_RIGHT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.25,
        mixBlendMode: 'multiply',
        src: IPHONES_AO_LEFT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.25,
        mixBlendMode: 'multiply',
        src: IPHONES_AO_RIGHT
    }, {
        type: IMAGE_LAYER,
        mixBlendMode: 'multiply',
        src: IPHONES_GRAPHICS_FACEBOOK
    }, {
        type: VARIATION_LAYER,
        transform: `translate(-43.4%, -46.8%) rotate(12.6deg) scale(${WIDE_SCALE})`
    }, {
        type: IMAGE_LAYER,
        opacity: 0.23,
        mixBlendMode: 'multiply',
        src: IPHONES_SHADOW_LEFT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.23,
        mixBlendMode: 'multiply',
        src: IPHONES_SHADOW_RIGHT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.07,
        mixBlendMode: 'soft-light',
        src: IPHONES_REFLECT_LEFT
    }, {
        type: IMAGE_LAYER,
        opacity: 0.10,
        mixBlendMode: 'soft-light',
        src: IPHONES_REFLECT_RIGHT
    }],
    aspectRatio: '56.25%'
};

export const squareMockUp = {
    layers: [{
        type: GRADIENT_LAYER,
        opacity: 0.54,
        background: 'transparent',
        transformOrigin: 'center',
        transform: 'scale(1.6)'
    }, {
        type: IMAGE_LAYER,
        src: IPHONES_BEAUTY_LEFT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.18,
        mixBlendMode: 'multiply',
        src: IPHONES_BEAUTY_LEFT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        mixBlendMode: 'multiply',
        src: IPHONES_GRAPHICS_INSTAGRAM,
        ...SQUARE_CROP_STYLE
    }, {
        type: VARIATION_LAYER,
        transform: `translate(-64.1%, -59%) rotate(-13.5deg) scale(${SQUARE_SCALE})`
    }, {
        type: IMAGE_LAYER,
        src: IPHONES_BEAUTY_RIGHT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.18,
        mixBlendMode: 'multiply',
        src: IPHONES_BEAUTY_RIGHT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.25,
        mixBlendMode: 'multiply',
        src: IPHONES_AO_LEFT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.25,
        mixBlendMode: 'multiply',
        src: IPHONES_AO_RIGHT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        mixBlendMode: 'multiply',
        src: IPHONES_GRAPHICS_FACEBOOK,
        ...SQUARE_CROP_STYLE
    }, {
        type: VARIATION_LAYER,
        transform: `translate(-38.1%, -44.3%) rotate(12.8deg) scale(${SQUARE_SCALE})`
    }, {
        type: IMAGE_LAYER,
        opacity: 0.23,
        mixBlendMode: 'multiply',
        src: IPHONES_SHADOW_LEFT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.23,
        mixBlendMode: 'multiply',
        src: IPHONES_SHADOW_RIGHT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.07,
        mixBlendMode: 'soft-light',
        src: IPHONES_REFLECT_LEFT,
        ...SQUARE_CROP_STYLE
    }, {
        type: IMAGE_LAYER,
        opacity: 0.10,
        mixBlendMode: 'soft-light',
        src: IPHONES_REFLECT_RIGHT,
        ...SQUARE_CROP_STYLE
    }],
    aspectRatio: '100%'
};
